module.exports = __webpack_public_path__ + "static/media/kitchens-1.646cb109.png";